// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sale-error[data-v-7ea289e8]{display:flex;flex-direction:column;align-items:center;justify-content:center}.sale-error__link[data-v-7ea289e8]{width:100%;text-decoration:none}.sale-error__title[data-v-7ea289e8]{margin-bottom:8px;font-size:20px;font-weight:500;line-height:26px}.sale-error__text[data-v-7ea289e8]{max-width:300px;margin-bottom:24px;font-size:16px;line-height:22px;text-align:center}.sale-error__img[data-v-7ea289e8]{margin-bottom:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
